module.exports = __webpack_public_path__ + "static/media/whatsapp.9500e026.png";